export enum EventStatusEnum {
  InProgress = 'in_progress',
  Incoming = 'incoming',
  Finished = 'finished'
}
